// Shared solutions catalog for the Home page summary and the Solutions page.
// Content mirrors the public iLAB Apps site (ilabapps.com). "Find out more"
// links resolve to that solution's page at ILABAPPS_BASE/{id}.

export const ILABAPPS_BASE = 'https://www.ilabapps.com/solution';

export const GROUP_META = {
  accelerator: {
    eyebrow: 'iLAB Accelerators',
    title: 'Mission-ready platforms',
    sub: 'Reusable platforms built for defense and federal missions. API-first, GovCloud-deployable, and designed for IL4/IL5 environments.',
  },
  solution: {
    eyebrow: 'Customer Solutions',
    title: 'Built for real missions',
    sub: 'Purpose-built solutions developed from direct customer needs, each adaptable for similar missions across defense and federal agencies.',
  },
};

export const SOLUTIONS = [
  {
    id: 'securex',
    prefix: 'iLAB',
    name: 'SecureX',
    tagline: 'From Evidence to Authorization',
    category: 'accelerator',
    blurb: 'Threat-informed ATO automation. Collects live evidence, generates AI compliance narratives, and exports submission-ready authorization packages.',
    highlights: ['GovCloud & IL5 ready', 'Deploys in your boundary', 'Continuous monitoring'],
  },
  {
    id: 'fast',
    prefix: 'iLAB',
    name: 'FAST',
    tagline: 'Federated AI Secure Transformation',
    category: 'accelerator',
    blurb: 'AI-first DevSecOps. AI agents detect and fix vulnerabilities at commit time and automate IL5, FedRAMP, and STIG compliance.',
    highlights: ['One-command deploy', 'IL5 / FedRAMP / STIG', 'Single-tenant isolation'],
  },
  {
    id: 'lattice',
    prefix: 'iLAB',
    name: 'Lattice',
    tagline: 'Productize Your Data',
    category: 'accelerator',
    blurb: 'Turn any database into a secure, documented REST API with auto-generated SDKs and dashboards, in minutes, not months.',
    highlights: ['Database to API in minutes', 'Runs in your enclave', 'Auto-generated SDKs & docs'],
  },
  {
    id: 'vortex',
    prefix: 'iLAB',
    name: 'Vortex',
    tagline: 'AI Decision Intelligence',
    category: 'accelerator',
    blurb: 'AI-powered decision analytics. Unify enterprise data, run predictive models, and ask plain-English questions with cited, explainable answers.',
    highlights: ['Plain-English querying', 'Cited, explainable answers', 'Predictive models'],
  },
  {
    id: 'nexuszero',
    prefix: 'iLAB',
    name: 'Nexus Zero',
    tagline: 'Multi-Agent AI for Compliance & GovCon',
    category: 'accelerator',
    blurb: 'A team of specialist AI agents for ATO documentation, CMMC and STIG assessment, DevSecOps review, and proposal support, running in your AWS account.',
    highlights: ['Runs in your AWS account', 'Guardrailed agents', 'Compliance + GovCon + DevSecOps'],
  },
  {
    id: 'pdms',
    prefix: 'iLAB',
    name: 'PDMS',
    tagline: 'Procurement Data You Can Trust',
    category: 'solution',
    blurb: 'Validates every procurement record against its source PDF, reconciles invoices, and joins contract documents into one trustworthy record.',
    highlights: ['Reconciled to source PDF', 'Full correction audit trail', 'One clean record per invoice'],
  },
  {
    id: 'armorx',
    prefix: '',
    name: 'ARMOR-X',
    tagline: 'Predictive Maintenance for Tactical Vehicles',
    category: 'solution',
    blurb: 'Edge AI that monitors vehicle health, predicts failures before they happen, and connects diagnostics directly to the parts supply chain.',
    highlights: ['On-device edge AI', 'Works offline, zero data loss', 'Integrated parts ordering'],
  },
];
